<template>
    <cms-block v-bind="$props" @block-selected="selectBlock">
        <b-row>
            <b-col v-if="block.image.isVisible()" :cols="imageSpan" :order="imageOrder" class="col flex" :style="imageContainerStyle"
                :class="{
                    'mb': isMobileLayoutOrPreview || block.mediaProxy.layout === 'default',
                    'mt': block.mediaProxy.layout === 'reverse'
                }">

                <cms-component-image comp-id="image" :component="block.image" v-bind="componentProps"/>
            </b-col>

            <b-col :cols="textSpan" class="col flex"
                :class="{
                    'mt': isMobileLayoutOrPreview || block.mediaProxy.layout === 'default',
                    'mb': block.mediaProxy.layout === 'reverse'
                }">

                <cms-component-glyph comp-id="glyph" :component="block.glyph" v-bind="componentProps"/>
                <cms-component-text comp-id="title" :component="block.title" placeholder="Title|Titre" v-bind="componentProps"/>
                <cms-component-text comp-id="subtitle" :component="block.subtitle" placeholder="Subtitle|Sous-titre" v-bind="componentProps"/>
                <cms-component-text comp-id="description" :component="block.description" placeholder="Description" v-bind="componentProps"/>

                <div class="group-buttons">
                    <cms-component-button comp-id="button" :component="block.button" placeholder="Button|Bouton" v-bind="componentProps"/>
                    <cms-component-button comp-id="altButton" class="ml-3" :component="block.altButton" placeholder="Alt Button" v-bind="componentProps"/>
                </div>
            </b-col>
        </b-row>
    </cms-block>
</template>

<script>
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import CmsComponentButton from "@/components/editor/rendering/components/cms-component-button.vue";
import CmsComponentImage from "@/components/editor/rendering/components/cms-component-image.vue";
import CmsComponentText from "@/components/editor/rendering/components/cms-component-text.vue";
import CmsComponentGlyph from "@components/editor/rendering/components/cms-component-glyph.vue";

// cms-block-text-and-image #hot-reload-debug
export default {
    name: `cms-block-text-and-image`,
    components: {CmsComponentGlyph, CmsComponentImage, CmsComponentButton, CmsComponentText, CmsBlock},
    extends: CmsBlock,
    computed: {
        imageContainerStyle() {
            let style = {};
            if (this.block.image.maxWidth && !this.isMobileLayoutOrPreview && !this.isLayoutColumn) {
                style.maxWidth = `calc(${this.block.image.maxWidth}px + var(--block-x-spacing) * 2)`;
            }
            return style;
        },
        cols() {
            if (this.isMobileLayoutOrPreview) {
                return 12;
            }
            return this.isLayoutColumn ? 12 : ``;
        },
        span() {
            return this.block.mediaProxy.span ?? 6;
        },
        imageSpan() {
            if (this.isMobileLayoutOrPreview || this.isLayoutColumn) {
                return 12;
            }
            return this.block.mediaProxy.layout === `row-left`
                ? this.span
                : 12 - this.span;
        },
        textSpan() {
            if (this.isMobileLayoutOrPreview || this.isLayoutColumn) {
                return 12;
            }
            return this.block.mediaProxy.layout === `row-left`
                ? 12 - this.span
                : this.span;
        },
        isLayoutColumn() {
            return this.block.mediaProxy.layout === `default` || this.block.mediaProxy.layout === `reverse`;
        },
        imageOrder() {
            return (this.block.mediaProxy.layout === `row-right` || this.block.mediaProxy.layout === `reverse`) ? 2 : 0;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
